import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, IconButton, Stack, Typography } from '@mui/material';

import { ReactComponent as EllipsisIcon } from 'assets/icons/EllipsisHorizontal.svg';

import { BottomSliderControlled } from 'components/_basic/BottomSlider';
import { Loader } from 'components/_basic/Loader/Loader';
import { RadioGroup } from 'components/_basic/RadioGroup/RadioGroup';

import { IViewProps } from './types';

import styles from './OnePageTypeSwitch.module.scss';

export const MobileView: FC<IViewProps> = ({ isPending, value, onChange, options }) => {
  const { t } = useTranslation();
  return (
    <BottomSliderControlled
      renderController={(onClick) => (
        <IconButton onClick={onClick}>
          <EllipsisIcon width={24} height={24} />
        </IconButton>
      )}
    >
      <Stack spacing={2}>
        <Typography variant="h5">{t('onePageType')}</Typography>
        {isPending ? (
          <Box className={styles.loaderWrapper}>
            <Loader size={30} />
          </Box>
        ) : (
          <RadioGroup value={value} onChange={onChange} options={options} />
        )}
      </Stack>
    </BottomSliderControlled>
  );
};
